import { t } from '@lingui/macro';

import { useQueryLoader } from '../../data-table/Loaders';
import { panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import Panel from '../../page-framework/panel/PanelDecorator';
import ReportingDataTable from '../../data-table/ReportingDataTable';

const COLUMNS = [
    {
        mapping: 'name',
        title: t`name`,
        width: 200,
        sortable: true,
    },
    {
        mapping: 'host',
        title: t`URL`,
        flex: 1,
        sortable: true,
    },
];

const dataSource = {
    url: '/pgm/api/v3/plms/list',
    params: {},
};

const sorters = [
    {
        property: 'name',
        direction: 'desc',
    },
];

function PLMList(props) {
    const loader = useQueryLoader(dataSource);
    return (
        <ReportingDataTable panelProps={props} loader={loader} columns={COLUMNS} visibleRows={0} sorters={sorters} />
    );
}

PLMList.defaultProps = {
    ...panelPropDefaults,
    title: t`PLM List`,
};

export default Panel()(PLMList);
